import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-heritage text-white py-20 lg:py-24 overflow-hidden">
      {/* Heritage Pattern Background */}
      <div className="absolute inset-0 heritage-pattern opacity-10"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-10 right-10 opacity-20">
        <Icon name="MapPin" size={120} className="text-golden" />
      </div>
      <div className="absolute bottom-10 left-10 opacity-15">
        <Icon name="Phone" size={80} className="text-textile" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-full p-4">
              <Icon name="MessageSquare" size={48} className="text-golden" />
            </div>
          </div>
          
          <h1 className="text-4xl lg:text-6xl font-poppins font-bold mb-6 animate-fade-in">
            Let's Connect & Create
          </h1>
          
          <p className="text-xl lg:text-2xl font-inter mb-8 max-w-3xl mx-auto opacity-90 animate-slide-up">
            Ready to transform your textile vision into reality? Our expert team is here to guide you through every step of your printing journey.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;